module.exports = __webpack_public_path__ + "postgres.4bac1441.svg";


//////////////////
// WEBPACK FOOTER
// ./src/db/img/postgres.svg
// module id = uRWs
// module chunks = 1